export default {
  targetsMetadata: {
    roleSelf: 'Мои',
    roleCurator: 'Я курирую',
    statuses: {
      awaitingReview: 'На согласовании',
      approved: 'Согласована',
      inProgress: 'В работе',
      inReview: 'На оценке руководителя/куратора',
      inReviewAssignee: 'На оценке сотрудника',
      completed: 'Завершена',
      cancelled: 'Отменена',
    },
    scoreLabels: {
      low: 'Не удалось добиться<br/>серьезного прогресса',
      middle: 'Добились прогресса,<br/>но не добились результата',
      high: 'Результат<br/>достигнут',
    },
    buttons: {
      approve: 'Согласовать',
      complete: 'Завершить и начать оценку',
      change: 'Да, изменить',
    },
    curator: 'Руководитель/Куратор',
    noCurator: 'не назначен',
    tableHeaders: {
      name: 'Наименование цели',
      importance: 'Важность',
      employeeScore: 'Оценка сотрудника',
      curatorScore: 'Оценка </br> руководителя/куратора',
      curatorScoreMobile: 'Оценка руководителя/куратора',
      employeeAvg: 'Средняя по самооценке',
      curatorAvg: 'Средняя по оценке </br> руководителя/куратора',
      efficiency: 'Эффективность',
      status: 'Статус',
      type: 'Тип',
      progress: 'Прогресс',
      deadline: 'Дедлайн',
    },
    confirmMoveTargets: {
      title: 'Изменить статус целей?',
      text: 'Статус выбранных целей будет изменён на: «{status}»',
    },
    tooltips: {
      efficiency: 'Процент завершенных целей от согласованных',
      scoreAvg:
        'Средняя рассчитана как среднее арифметическое взвешенное всех оценок по цели: сумма целей, умноженных на свои веса, делённая на сумму всех весов. Вес цели определяется автоматически в зависимости от установленной важности.',
    },
    successMessages: {
      moveTarget: 'Статус цели «{targetName}» успешно изменён',
    },
    errorMessages: {
      moveTarget: 'Не удалось изменить статус цели «{targetName}»',
    },
    noTargets:
      'У вас ещё нет ни одной цели. Чтобы добавить цель, нажмите на кнопку «Добавить цель»',
    noArchivalTargets: 'У вас ещё нет ни одной архивной цели.',
    disabledButton: 'Чтобы добавить цель, необходимо вступить в команду, где есть Лидер команды',
  },
};
